import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

export type FetchPixelTreeStatistics = () => void;

const fetchPixelTreeStatistics = (): AppThunk => async (dispatch: AppDispatch) => {
  await Promise.all([
    fetchReport("estimated_ads_tm", dispatch, {}),
    fetchReport("mtd_ads_pct_chg_vs_ly", dispatch, {}),
    fetchReport("mtd_ads_pct_chg_vs_lm", dispatch, {}),
    fetchReport("estimated_smbs_tm", dispatch, {}),
    fetchReport("mtd_smbs_pct_chg_vs_ly", dispatch, {}),
    fetchReport("mtd_smbs_pct_chg_vs_lm", dispatch, {}),
  ]);
};

export default fetchPixelTreeStatistics;
